export const fontFamily = '"Helvetica Neue", Arial, sans-serif'



// WEBPACK FOOTER //
// ./constants/index.js